var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPubli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "var(--main-forte)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1389 20.9722L18.0556 23.8889L24.8611 17.0833M28.75 20C28.75 24.8325 24.8325 28.75 20 28.75C15.1675 28.75 11.25 24.8325 11.25 20C11.25 15.1675 15.1675 11.25 20 11.25C24.8325 11.25 28.75 15.1675 28.75 20Z",
    stroke: "url(#paint0_linear_4_286)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_286",
    x1: 11.25,
    y1: 28.75,
    x2: 31.256,
    y2: 25.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1975FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPubli);
export default __webpack_public_path__ + "static/media/check_publi.b30a1c68eeeecff46ceba74215c60954.svg";
export { ForwardRef as ReactComponent };